import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Zurück, Hinzufügen } from '../icons';
import './DeviceDetail.css';
import './DeviceList.css';
import './OverviewAddedDevices.css';

const OverviewAddedDevices = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const result = location.state?.bulkUploadResult || {};

  const summary = {
    file_name: result.file_name || '-',
    total_rows: result.total_rows ?? '-',
    successful_count: result.successful_count ?? '-',
    failed_count: result.failed_count ?? '-',
  };

  const failedRows = Array.isArray(result.failed) ? result.failed : [];

  return (
    <div className="overview-added-devices">
      <div className="device-toolbar">
        <div className="device-toolbar-left">
          <h1 className="device-title">Übersicht hinzugefügter Geräte</h1>
        </div>
      </div>

      <div className="device-detail-grid overview-added-devices-grid">
        <div className="card-wrapper">
          <h2 id="overview-summary-title" className="card-title">Gesamtübersicht</h2>
          <section className="card" aria-labelledby="overview-summary-title">
            <table className="summary-table">
              <tbody>
                <tr>
                  <th scope="row">Dateiname:</th>
                  <td>{summary.file_name}</td>
                </tr>
                <tr>
                  <th scope="row">Gesamtzahl der ausgelesenen Zeilen:</th>
                  <td>{summary.total_rows}</td>
                </tr>
                <tr>
                  <th scope="row">Erfolgreich hinzugefügte Geräte:</th>
                  <td>{summary.successful_count}</td>
                </tr>
                <tr>
                  <th scope="row">Anzahl fehlgeschlagener Zeilen:</th>
                  <td>{summary.failed_count}</td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>

        <div className="card-wrapper">
          <h2 id="overview-failed-title" className="card-title">Übersicht über fehlgeschlagende Zeilen</h2>
          <section className="card" aria-labelledby="overview-failed-title">
            <div className="telemetry-scroll" style={{ maxHeight: '380px' }}>
              <table className="failed-rows-table">
                <thead>
                  <tr>
                    <th>Zeile im Dokument</th>
                    <th>Grund für Fehlgeschlagene Zeile</th>
                  </tr>
                </thead>
                <tbody>
                  {failedRows.length === 0 ? (
                    <tr>
                      <td colSpan={2}>Keine fehlgeschlagenen Zeilen</td>
                    </tr>
                  ) : (
                    failedRows.map((entry, index) => (
                      <tr key={`${entry.row ?? 'row'}-${index}`}>
                        <td>{entry.row ?? '-'}</td>
                        <td>{entry.detail ?? '-'}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>

      <div className="overview-added-devices-actions">
        <button className="overview-action-btn" onClick={() => navigate('/devices')}>
          <Zurück /> Zur Geräteübersicht
        </button>
        <button className="overview-action-btn" onClick={() => navigate('/add-device')}>
          <Hinzufügen /> Weitere Geräte hinzufügen
        </button>
      </div>
    </div>
  );
};

export default OverviewAddedDevices;